export const notes = [
  { matiere: "Mathématiques", note: 17, coefficient: 3, commentaire: "Très bon travail", date: "2025-09-10" },
  { matiere: "Français", note: 14, coefficient: 2, commentaire: "Bonne copie, peut mieux faire", date: "2025-09-09" },
  { matiere: "Histoire", note: 16, coefficient: 1, commentaire: "Participation active", date: "2025-09-08" },
  { matiere: "Anglais", note: 12, coefficient: 2, commentaire: "Doit améliorer la compréhension orale", date: "2025-09-07" },
  { matiere: "SVT", note: 18, coefficient: 1, commentaire: "Excellent", date: "2025-09-06" }
];
